<!-- ProcessingIcon はSSM5画面の最前面に表示する -->
<div v-if="processing" class="common-loading-bg">
  <div class="common-loading"></div>
</div>